// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"a5368385","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"08814d10","726":"633dee0c"}[chunkId] + ".chunk.js";
};